const variables = {
  showBackground: true,
};

export default variables;
